<template>
    <be-card flat table class="assessment-question">
        <div class="row">
            <div class="col">
                <label class="col-form-label">{{ data.title }}</label>
                <p>{{ data.description }}</p>
                <range-slider
                    :min="scores.min"
                    :max="scores.max"
                    :disabled="disabled"
                    :value="score"
                    :pips="{ mode: 'steps', density: 100 / scores.max, filter: filterPip }"
                    @input="output => $emit('update:score', output)"
                />
            </div>
            <div class="col-12 col-xl-8">
                <label class="col-form-label">Bemerkungen zu {{ data.title }}</label>
                <div class="row no-gutters">
                    <div class="col-md-3 d-flex flex-column score-info">
                        <strong>{{scores.min}} = Nicht erfüllt</strong>
                        <div class="flex-grow-1" v-html="parseMarkup(data.scoreInfo0)"></div>
                    </div>
                    <div class="col-md-3 d-flex flex-column score-info">
                        <strong>{{scores.mid}} = tw. erfüllt</strong>
                        <div class="flex-grow-1" v-html="parseMarkup(data.scoreInfo5)"></div>
                    </div>
                    <div class="col-md-3 d-flex flex-column score-info">
                        <strong>{{scores.max}} = Erfüllt</strong>
                        <div class="flex-grow-1" v-html="parseMarkup(data.scoreInfo10)"></div>
                    </div>
                    <div class="col-md-3 d-flex flex-column score-notes">
                        <strong>Notizen</strong>
                        <div class="flex-grow-1"><text-area :name="`${data.id}_notes`" :value="notes" :disabled="disabled" @input="output => { $emit('update:notes', output) }"/></div>
                    </div>
                </div>
            </div>
        </div>
    </be-card>
</template>

<script>
    import markup from '../../../../mixins/markup';
    import Assessment from '../../../../models/Assessment';

    export default {
        mixins: [markup],

        props: {
            data: {
                type: Object,
                required: true,
            },
            score: Number,
            notes: String,
            disabled: Boolean,
        },

        computed: {
            scores: () => Assessment.defaultScores,
            filterPip: vm => v => ((v === vm.scores.min || v === vm.scores.max || v === vm.scores.mid) ? 1 : 2),
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .assessment-question {
        .score-info,
        .score-notes {
            strong {
                display: block;
                padding: 1em 1em;
                border-bottom: 2px solid #ddd;
            }

            div {
                padding: 1em .5em 0 0;
                background: #f5f5f5;
            }
        }

        .score-notes {
            div {
                padding: .5em .5em 0;
            }
        }
    }
</style>
